<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(task.id)" v-if="task.id && $can('task-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.title"
                  v-model="task.title"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('tasks.name')"
                  :error-messages="errors.collect('task.title')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="task.place"
                  v-model="task.place"
                  :label="$t('tasks.place')"
                  :error-messages="errors.collect('task.place')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="task.instructor_id"
                  v-model="task.instructor_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="instructors"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('tasks.instructor_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('task.instructor_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="start_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="task.start_date"
                      v-model="computedTaskStartDate"
                      :label="$t('tasks.start_date')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('task.start_date')"
                      append-icon="event"
                      @click:append="start_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      @change="startDateTimeChange"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="task.start_date"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                    @change="startDateTimeChange"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="start_time_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="task.start_time"
                      v-model="computedTaskStartTime"
                      :label="$t('tasks.start_time')"
                      class="required-field"
                      v-validate="'required|validTime'"
                      :error-messages="errors.collect('task.start_time')"
                      append-icon="event"
                      @click:append="start_time_menu = true"
                      :hint="'Format: ' + TIME_FORMAT"
                      @change="startDateTimeChange"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="task.start_time" format="24hr" @change="startDateTimeChange">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="end_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="task.end_date"
                      v-model="computedTaskEndDate"
                      :label="$t('tasks.end_date')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('task.end_date')"
                      append-icon="event"
                      @click:append="end_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      @change="endDateTimeChange"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="task.end_date"
                    first-day-of-week="1"
                    :locale="this.$locale_bcp47()"
                    :min="task.start_date"
                    @change="endDateTimeChange"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="end_time_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="task.end_time"
                      v-model="computedTaskEndTime"
                      :label="$t('tasks.end_time')"
                      class="required-field"
                      v-validate="'required|validTime'"
                      :error-messages="errors.collect('task.end_time')"
                      append-icon="event"
                      @click:append="end_time_menu = true"
                      :hint="'Format: ' + TIME_FORMAT"
                      @change="endDateTimeChange"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="task.end_time" format="24hr" @change="endDateTimeChange">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="task.status"
                  v-model="task.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_task_status()"
                  :label="$t('tasks.status')"
                  :error-messages="errors.collect('task.status')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="task.description"
                  v-model="task.description"
                  v-validate="'max:1000'"
                  :label="$t('tasks.description')"
                  :error-messages="errors.collect('task.description')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TaskTypesForm",

  props: ["id", "modal", "start_date", "start_time", "end_date", "end_time"],

  data() {
    return {
      page_title: "",
      predata: {},
      task: {},
      tasktypes: [],
      classes: [],
      instructors: [],
      start_date_menu: false,
      start_time_menu: false,
      end_date_menu: false,
      end_time_menu: false,
      dictionary: {
        attributes: {
          "task.title": this.$t("tasks.name"),
          "task.description": this.$t("tasks.description"),
          "task.place": this.$t("tasktypes.place"),
          "task.start_date": this.$t("tasks.start_date"),
          "task.start_time": this.$t("tasks.start_time"),
          "task.end_date": this.$t("tasks.end_date"),
          "task.end_time": this.$t("tasks.end_time"),
          "task.instructor_id": this.$t("tasks.instructor_id"),
          "task.status": this.$t("tasks.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.task, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedTaskStartDate: {
      get(val) {
        return this.$dateFormatGetter(this.task.start_date)
      },
      set(val) {
        this.$set(this.task, "start_date", this.$dateFormatSetter(val))
      }
    },
    computedTaskStartTime: {
      get() {
        return this.$timeFormatGetter(this.task.start_time)
      },
      set(val) {
        this.$set(this.task, "start_time", this.$timeFormatSetter(val))
      }
    },
    computedTaskEndDate: {
      get(val) {
        return this.$dateFormatGetter(this.task.end_date)
      },
      set(val) {
        this.$set(this.task, "end_date", this.$dateFormatSetter(val))
      }
    },
    computedTaskEndTime: {
      get() {
        return this.$timeFormatGetter(this.task.end_time)
      },
      set(val) {
        this.$set(this.task, "end_time", this.$timeFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    // Get Instructors
    axios.get(this.API_URL + "users?show_all=true&query_is_instructor=1").then((res) => {
      this.instructors = res.data.data

      // Get Task
      if (!this.id) {
        this.page_title = this.$t("tasks.new_task")
        this.task = {
          status: this.$getDefaultDropdown(this.$dd_task_status()),
          start_date: this.start_date,
          start_time: this.start_time,
          end_date: this.end_date,
          end_time: this.end_time
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.task))
      } else {
        this.title = this.$t("tasks.update_title")

        axios
          .get(this.API_URL + "task/" + this.id)
          .then((res) => {
            this.task = res.data.data

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.task))

            this.page_title = this.$t("tasks.edit_task", {
              name: this.task.title
            })
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    startDateTimeChange() {
      if (this.task.start_date && this.task.start_time && this.task.end_date && this.task.end_time) {
        let task_start = this.moment(this.task.start_date + " " + this.task.start_time)
        let task_end = this.moment(this.task.end_date + " " + this.task.end_time)

        if (task_start > task_end) {
          this.task.end_date = JSON.parse(JSON.stringify(this.task.start_date))
          this.task.end_time = JSON.parse(JSON.stringify(this.task.start_time))
        }
      }
    },
    endDateTimeChange() {
      if (this.task.start_date && this.task.start_time && this.task.end_date && this.task.end_time) {
        let task_start = this.moment(this.task.start_date + " " + this.task.start_time)
        let task_end = this.moment(this.task.end_date + " " + this.task.end_time)

        if (task_start > task_end) {
          this.task.end_date = JSON.parse(JSON.stringify(this.task.start_date))
          this.task.end_time = JSON.parse(JSON.stringify(this.task.start_time))
        }
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.task.id) {
              // Create
              axios
                .post(this.API_URL + "task", {
                  title: this.task.title,
                  description: this.task.description,
                  place: this.task.place,
                  start_date: this.task.start_date,
                  start_time: this.task.start_time,
                  end_date: this.task.end_date,
                  end_time: this.task.end_time,
                  instructor_id: this.task.instructor_id,
                  status: this.task.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "task",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.task = res.data.data
                        vm.predata = JSON.parse(JSON.stringify(vm.task))

                        this.page_title = this.$t("tasks.edit_task", {
                          name: this.task.title
                        })

                        vm.$router.replace(this.BACKEND_URL + `/tasks/edit/${vm.task.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "task", {
                  id: this.task.id,
                  title: this.task.title,
                  description: this.task.description,
                  place: this.task.place,
                  start_date: this.task.start_date,
                  start_time: this.task.start_time,
                  end_date: this.task.end_date,
                  end_time: this.task.end_time,
                  instructor_id: this.task.instructor_id,
                  status: this.task.status
                })
                .then((res) => {
                  vm.task = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.task))

                  this.page_title = this.$t("tasks.edit_task", {
                    name: this.task.title
                  })

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "task",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "task/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/tasks")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
